import moment from 'moment';

/**
 * Validate stringDate
 * @param stringDate
 * @param formats
 * @param nullable
 * @returns {boolean}
 */
export const isDateValid = (stringDate, formats = ['DD/MM/YYYY'], nullable = true) => {
  if ((stringDate === null || stringDate === '') && nullable) return true;
  const date = moment(stringDate, formats, true);
  return date.isValid();
};

export const isHourValid = (stringHour, format = 'HH:mm:ss', nullable = true) => {
  if ((stringHour === null || stringHour === '') && nullable) return true;
  const hour = moment(stringHour, [format], true);
  return hour.isValid();
};

export const isDateTodayOrFutureAndValid = (stringDate, formats = ['DD/MM/YYYY'], nullable = true) => {
  const valid = isDateValid(stringDate, formats, nullable);
  const now = moment();
  const date = moment(stringDate, formats, true);
  return valid && date.isSameOrAfter(now);
};
